module.exports = __webpack_public_path__ + "media/components/Shared/AudioPlayer/icons/checkmark-ebe38c3f5e7f7549eb92418401bf1ba0.png";